import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TokenStorageService } from '../../services/safeguard/token-storage.service';
import { ErrorProcessorService }  from "../../shared/services/error-processor.service";


@Injectable({
  providedIn: 'root'
})
export class JobService {

  private readonly refreshDaqDataUrl = "/admin/jobs/refresh-daq-data/{brandCode}";
  private readonly importInboundFeedsUrl = "/admin/jobs/import-inbound-feeds/{brandCode}";
  private readonly generateOutboundFeedsUrl = "/admin/jobs/generate-outbound-feeds/{brandCode}";
  private readonly runAndroidScannerUrl = "/admin/jobs/run-android-scanner/{brandCode}";
  private readonly triggeredActionUrl = "/admin/jobs/triggered-action/{brandCode}/{eventName}";
  private readonly rtpnBarcodeRefresherUrl = "/admin/jobs/rtpn-barcode-refresher/{brandCode}";

  private readonly triggerScheduledEventUrl = "/admin/scheduled-events/{eventName}/execute";

  constructor(
    private readonly http: HttpClient,
    private readonly tokenStorageService: TokenStorageService,
    private readonly errorProcessorService: ErrorProcessorService    
  ) { }


  triggerEvent(brandCode: string, taskName: string, baseUrl: string) {
    let url = baseUrl;
    if (taskName.indexOf("DaqDataBatchRefresher") >= 0) {
      url += this.refreshDaqDataUrl.replace('{brandCode}', brandCode);
    } else if (taskName.indexOf("GenericDaqDatafeedImporter") >= 0) {
      url += this.importInboundFeedsUrl.replace('{brandCode}', brandCode);
    } else if (taskName.indexOf("GenericOutgoingDatafeedGenerator") >= 0) {
      url += this.generateOutboundFeedsUrl.replace('{brandCode}', brandCode);
    } else if (taskName.indexOf("AndroidPayScanner") >= 0) {
      url += this.runAndroidScannerUrl.replace('{brandCode}', brandCode);
    } else if (taskName.indexOf("RtpnBatchBarcodeRefresher") >= 0) {
      url += this.rtpnBarcodeRefresherUrl.replace('{brandCode}', brandCode);
    } else {
      url += this.triggeredActionUrl.replace('{brandCode}', brandCode).replace('{eventName}', taskName);
    }
    return this.http.post<string>(url, null, {responseType: 'json'})
    .pipe(
      catchError(this.errorProcessorService.handleError)
    )
  } 

  executeEvent(eventName: string, baseUrl: string) {
    let url = this.schedulerBaseUrl(baseUrl) 
        + this.triggerScheduledEventUrl.replace('{eventName}', eventName);
    return this.http.post<string>(url, null, {responseType: 'json'})
    .pipe(
      catchError(this.errorProcessorService.handleError)
    )
  } 

  schedulerBaseUrl(baseUrl: string) {
    if (baseUrl.toLowerCase().indexOf('scheduler/api') >= 0) {
      return baseUrl;
    }
    return baseUrl.toLowerCase().replace('walletron/api','scheduler/api');
  }  

}
